module.exports = __webpack_public_path__ + "64f13506ed934680816509b0f007169a.svg";